<template>
  <b-card class="card-painel">
    <b-row>
      <b-col cols="12">
        <painel-oportunidades-header
          :funis="funis"
          :funil-selecionado="funilSelecionado"
          @funil-change="selecionarFunil"
          @funil-criado="onFunilCriado"
          @etapa-criada="onEtapaCriada"
          @oportunidade-criada="onOportunidadeCriada"
        />

        <div
          v-if="!funis || funis.length === 0"
          style="display: flex; justify-content: center; margin-top: 20px;"
        >
          <p style="font-style: italic; color: gray; font-size: 18px;">
            Cadastre um funil na lista de selecao para poder gerenciar suas oportunidades.
          </p>
        </div>

        <oportunidades-quadro
          ref="oportunidadesQuadro"
          :funil-selecionado="funilSelecionado"
          :drag-options="dragOptions"
          @open-deal="handleOpenDeal"
          @refresh-funil="refreshFunil"
        />

        <modal-detalhes-oportunidade
          ref="modalDetalhesOportunidade"
          :oportunidade-id="detalheOportunidadeId"
        />
      </b-col>
    </b-row>
  </b-card>
</template>

<style>

:root {
  --comercial-green: var(--comercial-primary, #16a34a);
  --comercial-green-dark: var(--comercial-primary-dark, #15803d);
  --comercial-green-soft: rgba(22, 163, 74, 0.12);
}

.alteracao-tamanho {
  width: 1600px !important;
  max-width: 96vw !important;
}

.center-modal .modal-dialog {
  margin-top: 18px !important;
  margin-bottom: 18px !important;
}

.center-modal .modal-content {
  min-height: 70vh !important;
}

.center-modal .modal-body {
  padding-bottom: 18px !important;
}

.deal-modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 18px 14px 18px;
}

.deal-header-left {
  min-width: 0;
  flex: 1;
}

.deal-title-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.deal-icon {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--comercial-green-soft);
  color: var(--comercial-green-dark);
  flex: 0 0 auto;
}

.deal-title-stack {
  min-width: 0;
}

.deal-kicker {
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #6c757d;
  line-height: 1.2;
}

.deal-kicker-id {
  color: var(--comercial-green-dark);
}

.deal-title {
  margin: 4px 0 6px 0;
  font-size: 18px;
  line-height: 1.2;
  font-weight: 900;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 70vw;
}

.deal-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 14px;
  align-items: center;
}

.deal-meta--stack {
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
}

.deal-meta-item {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.deal-meta-text {
  font-size: 13px;
  color: #6c757d;
  line-height: 1.15;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 70vw;
}

.deal-header-cnpj {
  display: flex;
  align-items: center;
  gap: 6px;
}

.btn-copy-cnpj {
  line-height: 1;
  text-decoration: none !important;
  color: #6c757d !important;
}

.btn-copy-cnpj:hover {
  color: #343a40 !important;
}

.deal-header-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 70vw;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: bottom;
  color: inherit;
  text-decoration: none;
  background-image: linear-gradient(var(--comercial-green), var(--comercial-green));
  background-position: 0 100%;
  background-repeat: no-repeat;
  background-size: 0% 2px;
  transition: background-size 220ms ease, transform 220ms ease, opacity 220ms ease;
  opacity: 0.95;
}

.deal-header-link:hover {
  background-size: 100% 2px;
  transform: translateX(2px);
  opacity: 1;
}

.deal-address-icon {
  color: var(--comercial-green-dark);
}

.deal-header-right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 0 0 auto;
}

.deal-modal-divider {
  height: 1px;
  background: #e9ecef;
  margin: 0 18px 12px 18px;
}

.detalhe-modal {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0 10px 10px 10px;
}

.painel-info {
  border: 1px solid #eef1f4;
  border-radius: 14px;
  padding: 16px;
  background: #ffffff;
  box-shadow: 0 10px 25px rgba(17, 24, 39, 0.06);
  position: relative;
  align-self: flex-start;
  height: fit-content;
}

.painel-info--premium:before {
  content: "";
  position: absolute;
  left: 0;
  top: 12px;
  bottom: 12px;
  width: 4px;
  border-radius: 999px;
  background: linear-gradient(180deg, var(--comercial-green), rgba(22, 163, 74, 0.30));
}

.info-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 14px;
  padding-left: 10px;
}

.info-subtitle {
  display: block;
  margin-top: 2px;
  color: #6b7280;
  font-size: 12px;
  font-weight: 500;
}

.info-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-left: 10px;
}

.info-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px;
  border: 1px solid #f1f5f9;
  border-radius: 12px;
  background: #ffffff;
  transition: box-shadow 160ms ease, border-color 160ms ease, transform 160ms ease;
}

.info-item:hover {
  border-color: rgba(22, 163, 74, 0.18);
  box-shadow: 0 10px 18px rgba(22, 163, 74, 0.08);
  transform: translateY(-1px);
}

.info-item--stack {
  padding: 12px;
}

.info-item-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
}

.info-icon-wrap {
  width: 34px;
  height: 34px;
  border-radius: 12px;
  background: var(--comercial-green-soft);
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  color: var(--comercial-green-dark);
}

.info-icon {
  font-size: 15px;
}

.info-content {
  flex: 1;
  min-width: 0;
}

.info-label {
  display: block;
  font-size: 11px;
  font-weight: 900;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.info-label--bigger {
  font-size: 12px;
  letter-spacing: 0.04em;
}

.info-value {
  font-weight: 700;
  color: #111827;
  margin-top: 4px;
  display: block;
  white-space: normal;
  word-break: break-word;
}

.info-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.info-pill {
  min-width: 26px;
  height: 22px;
  padding: 0 8px;
  border-radius: 999px;
  border: 1px solid #eef1f4;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 900;
  color: #111827;
  background: #ffffff;
}

.ratio-bar {
  width: 100%;
  height: 10px;
  border-radius: 999px;
  background: #eef1f4;
  overflow: hidden;
  display: flex;
  margin-top: 10px;
}

.ratio-bar--empty {
  background: #eef1f4;
}

.ratio-seg {
  height: 100%;
}

.ratio-seg--green {
  background: #16a34a;
}

.ratio-seg--yellow {
  background: #f59e0b;
}

.ratio-seg--red {
  background: #ef4444;
}

.ratio-legend {
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  font-size: 12px;
  color: #6b7280;
  font-weight: 800;
}

.legend-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.legend-total {
  margin-left: auto;
  color: #6b7280;
  font-weight: 900;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  display: inline-block;
}

.dot--green { background: #16a34a; }
.dot--yellow { background: #f59e0b; }
.dot--red { background: #ef4444; }

.painel-conteudo {
  flex: 1;
}

.empresa-info-wrapper {
  padding: 6px 10px 18px 10px;
}

.empresa-info-card {
  border: 1px solid #eef1f4;
  border-radius: 14px;
  background: #fff;
  padding: 14px;
  box-shadow: 0 10px 20px rgba(17, 24, 39, 0.04);
}

.empresa-info-card-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 18px;
}

.empresa-info-subtitle {
  margin-left: 16px;
  padding-top: 2px;
  display: inline-block;
}

.empresa-info-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
  align-items: start;
}

.empresa-info-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.empresa-info-label {
  font-weight: 900;
  color: #111827;
  font-size: 11px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  line-height: 1.2;
}

.empresa-info-value {
  font-weight: 600;
  color: #111827;
  font-size: 14px;
  line-height: 1.25;
}

.empresa-info-wrap {
  white-space: normal;
  word-break: break-word;
}

.abas > .card-header {
  padding-top: 6px !important;
  padding-bottom: 6px !important;
  min-height: unset !important;
  background: #ffffff !important;
  border-bottom: 1px solid #eef1f4 !important;
}

.abas .nav-pills .nav-link {
  border-radius: 999px !important;
  font-weight: 800;
  font-size: 12px;
  padding: 8px 12px;
  color: #6b7280;
  border: 1px solid transparent;
}

.abas .nav-pills .nav-link:hover {
  color: #111827;
  border-color: #eef1f4;
}

.abas .nav-pills .nav-link.active,
.abas .nav-pills .show > .nav-link {
  background: var(--comercial-green) !important;
  border-color: var(--comercial-green) !important;
  color: #ffffff !important;
  box-shadow: 0 10px 18px rgba(22, 163, 74, 0.18);
}

@media (max-width: 991px) {
  .empresa-info-grid {
    grid-template-columns: 1fr;
  }

  .deal-title {
    max-width: 60vw;
  }

  .deal-meta-text {
    max-width: 60vw;
  }
}

@media (min-width: 992px) {
  .detalhe-modal {
    flex-direction: row;
  }

  .painel-info {
    flex: 0 0 23%;
    max-width: 27%;
  }

  .painel-conteudo {
    flex: 0 0 73%;
    max-width: 73%;
    padding-left: 14px;
  }
}

.card-atrasado {
  background-color: #fff7f7;
  border: 1.5px solid #e96262;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
}

.card-atrasado:hover {
  border-color: #e27c7c;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.06);
  background-color: #e55353;
}

.card-atrasado:hover,
.card-atrasado:hover p,
.card-atrasado:hover strong,
.card-atrasado:hover .card-value-badge,
.card-atrasado:hover .card-owner {
  transition: 0.3s;
  color: #ffffff !important;
}

.card-atrasado:hover .card-value-badge {
  background-color: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}

.quadro {
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 10px;
  margin-top: 20px;
  height: calc(100vh - 260px);
  scrollbar-width: thin;
  scrollbar-color: rgba(0,0,0,0.2) transparent;
}

.quadro::-webkit-scrollbar {
  height: 8px;
}

.quadro::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

.quadro-inner {
  display: flex;
  flex-wrap: nowrap;
  gap: 1rem;
  min-width: max-content;
}

.transition-wrapper {
  display: flex;
  flex-wrap: nowrap;
  gap: 1rem;
}

.stage-column {
  flex: 0 0 380px;
  background: #f8f9fa;
  border-radius: 14px;
  padding: 1rem;
  height: calc(100vh - 300px);
  overflow-y: auto;
  overflow-x: hidden;
  box-shadow: 0 2px 4px rgba(0,0,0,0.08);
  border: 1px solid #eef1f4;
}

.stage-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.stage-handle {
  cursor: grab;
  color: #6c757d;
  transition: color 0.2s;
}

.stage-handle:hover {
  color: #343a40;
}

.stage-color-bar {
  height: 6px;
  width: 100%;
  border-radius: 999px;
  margin-bottom: 10px;
}

.stageName {
  font-weight: 900;
  font-size: 14px;
  margin-bottom: 10px;
  color: #111827;
}

.card-item {
  background: #fff;
  border-radius: 14px;
  margin-bottom: 1rem;
  box-shadow: 0 2px 6px rgba(0,0,0,0.07);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  border: 1px solid #eef1f4;
}

.card-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 22px rgba(0,0,0,0.10);
}

.card-title {
  padding: 0.85rem 1rem 0 1rem;
  font-size: 13px !important;
  font-weight: 900 !important;
  border-bottom: none !important;
  color: #111827;
  margin: 0;
  white-space: normal;
  word-break: break-word;
  line-height: 1.35;
  display: block;
}

.card-info {
  font-size: 12px !important;
  color: #495057;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.card-info p {
  margin: 0;
  line-height: 1.4;
}

.card-footer-expected {
  padding: 0.65rem 1rem !important;
  border-top: 1px solid #eef1f4;
  display: flex;
  justify-content: space-between !important;
  align-items: center;
}

.card-value-badge {
  display: flex;
  align-items: center;
  background-color: rgba(22, 163, 74, 0.12);
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 900;
  color: #14532d;
}

.card-owner {
  font-size: 12px;
  color: #6c757d;
  display: flex;
  align-items: center;
  max-width: 60%;
}

.owner-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 4px;
}

.empty-drop-zone {
  min-height: 60px;
  border-top: 2px dashed #ccc;
  background: transparent;
  display: flex;
  align-items: baseline;
  gap: 1rem;
  padding-top: 1rem;
  justify-content: center;
  color: #aaa;
  font-size: 13px;
}

.card-tags {
  padding: 0 1rem;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

</style>

<script>
import {
  faPlus,
  faInfoCircle,
  faFolderOpen,
  faBuilding,
  faCalendarAlt,
  faClipboardList,
  faTimes,
  faSave,
  faClock,
  faBell,
  faCopy,
  faMapMarkerAlt,
  faFileSignature,
  faFileInvoiceDollar,
} from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'
import api from '@/app-modulo/comercial/oportunidades/shared/services/api'
import etiquetasApi from '@/app-modulo/comercial/cadastro-proposta/shared/components/cadastro-etiqueta/services/api'
import * as oppUtils from '@/app-modulo/comercial/oportunidades/shared/utils'
import PainelOportunidadesHeader from '@/app-modulo/comercial/oportunidades/shared/components/painel/PainelOportunidadesHeader.vue'
import OportunidadesQuadro from '@/app-modulo/comercial/oportunidades/shared/components/painel/OportunidadesQuadro.vue'
import ModalDetalhesOportunidade from '@/app-modulo/comercial/oportunidades/shared/components/modal-detalhes-oportunidade/ModalDetalhesOportunidade.vue'

export default {
  name: 'PainelOportunidades',
  components: {
    PainelOportunidadesHeader,
    OportunidadesQuadro,
    ModalDetalhesOportunidade,
  },
  data() {
    return {
      faPlus,
      faInfoCircle,
      faFolderOpen,
      faBuilding,
      faCalendarAlt,
      faClipboardList,
      faTimes,
      faSave,
      faClock,
      faBell,
      faCopy,
      faMapMarkerAlt,
      faFileSignature,
      faFileInvoiceDollar,

      funis: [],
      funisEtapasOportunidades: {
        stages: [],
      },
      funilSelecionado: null,

      statusOpcoes: [
        { value: 'Em andamento', text: 'Em andamento' },
        { value: 'Concluida', text: 'Concluida' },
        { value: 'Perdida', text: 'Perdida' },
        { value: 'Aguardando cliente', text: 'Aguardando cliente' },
        { value: 'Cancelada', text: 'Cancelada' },
      ],
      propostaIdAtual: null,
      detalheOportunidadeId: null,
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      }
    },
  },

  watch: {
    '$route.query.dealId': {
      immediate: true,
      handler(newId) {
        if (!newId) return
        this.abrirOportunidadeComContexto(newId)
      },
    },
    '$route.params.oportunidadeId': {
      immediate: true,
      handler(newId) {
        if (!newId) return
        this.abrirOportunidadeComContexto(newId)
      },
    },
  },

  created() {
    this.carregarFunis()
  },

  methods: {
    refreshFunil() {
      this.$refs.oportunidadesQuadro.carregarEtapasEPropostas(this.funilSelecionado)
    },
    // evita ternário aninhado
    toStringTrim(value) {
      if (value === null || value === undefined) return ''
      if (typeof value === 'string') return value.trim()
      return String(value).trim()
    },

    onFunilCriado(novoFunil) {
      if (novoFunil && novoFunil.id) {
        this.funis.push(novoFunil)
        this.funilSelecionado = novoFunil.id
        this.$forceUpdate()
      }
    },

    hidratarCamposLivresDoCadastro(empresa) {
      if (!empresa) return
      const hydrated = oppUtils.hidratarCamposLivresDoCadastro(empresa)
      if (!this.empresaLivres) this.empresaLivres = {}
      this.empresaLivres = { ...this.empresaLivres, ...hydrated }
    },

    extrairCnaePrincipal(empresa) {
      return oppUtils.extrairCnaePrincipal(empresa)
    },

    extrairEnquadramento(empresa) {
      return oppUtils.extrairEnquadramento(empresa)
    },

    async copiarCnpj() {
      const texto = this.empresaHeaderCnpjRaw
      if (!texto) return
      await this.copiarTexto(texto, 'CNPJ copiado!')
    },

    async copiarTexto(texto, msgSucesso = 'Copiado!') {
      if (!texto) return
      try {
        if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(texto)
        } else {
          const textarea = document.createElement('textarea')
          textarea.value = texto
          textarea.setAttribute('readonly', '')
          textarea.style.position = 'absolute'
          textarea.style.left = '-9999px'
          document.body.appendChild(textarea)
          textarea.select()
          document.execCommand('copy')
          document.body.removeChild(textarea)
        }
        if (this.$sucesso) this.$sucesso(msgSucesso)
      } catch (e) {
        if (this.$erro) this.$erro('Não foi possível copiar.')
      }
    },

    async carregarEmpresaCadastro(empresaId) {
      this.empresaCadastro = null
      if (!empresaId) return
      this.carregandoEmpresaCadastro = true
      try {
        const response = await oppUtils.getEmpresa(empresaId)
        this.empresaCadastro = response && response.data ? response.data : null
        this.hidratarCamposLivresDoCadastro(this.empresaCadastro)
      } catch (error) {
        this.empresaCadastro = null
      } finally {
        this.carregandoEmpresaCadastro = false
      }
    },
    carregarFunis() {
      this.$isLoading(true)
      api.getActivePipelines()
        .then(response => {
          this.funis = response.data
          const [primeiroFunil] = this.funis
          this.funilSelecionado = primeiroFunil.id
        })
        .catch(() => {
          this.$erro('Erro ao carregar funis, tente novamente mais tarde.')
        }).finally(() => {
          this.$isLoading(false)
        })
    },

    normalizarEtiqueta(tag) {
      if (!tag) return null

      let id = null
      if (tag.id !== undefined) id = tag.id
      else if (tag.Id !== undefined) id = tag.Id
      else if (tag.etiquetaId !== undefined) id = tag.etiquetaId
      else if (tag.EtiquetaId !== undefined) id = tag.EtiquetaId

      let descricao = ''
      if (tag.descricao !== undefined) descricao = tag.descricao
      else if (tag.Descricao !== undefined) descricao = tag.Descricao
      else if (tag.nome !== undefined) descricao = tag.nome
      else if (tag.name !== undefined) descricao = tag.name

      descricao = this.toStringTrim(descricao)

      let cor = ''
      if (tag.cor !== undefined) cor = tag.cor
      else if (tag.Cor !== undefined) cor = tag.Cor
      else if (tag.color !== undefined) cor = tag.color

      cor = this.toStringTrim(cor) || '#6c757d'

      let selecionada
      if (tag.selecionada !== undefined) selecionada = tag.selecionada
      else if (tag.Selecionada !== undefined) selecionada = tag.Selecionada

      return {
        id,
        descricao,
        cor,
        selecionada,
      }
    },

    escolherPropostaIdParaEtiquetas(propostas) {
      const list = Array.isArray(propostas) ? propostas.filter(p => p && p.id) : []
      if (!list.length) return null

      const aprovadas = list.filter(p => this.isPropostaAprovada(p))
      const baseList = aprovadas.length ? aprovadas : list
      const ids = baseList
        .map(p => Number(p.id))
        .filter(n => Number.isFinite(n))
        .sort((a, b) => b - a)

      return ids[0] || null
    },

    async carregarEtiquetasProposta(propostaId) {
      if (!propostaId) return []
      const res = await etiquetasApi.getEtiquetasProposta(propostaId)
      const arr = Array.isArray(res && res.data ? res.data : null) ? res.data : []
      return arr
        .map(t => this.normalizarEtiqueta(t))
        .filter(t => t && (t.selecionada === undefined || t.selecionada === true))
        .map(t => ({
          id: t.id,
          descricao: t.descricao,
          cor: t.cor,
        }))
    },

    // === PROPOSTAS / PACOTE / HONORÁRIOS ===
    isPropostaAprovada(p) {
      if (!p) return false
      const stNum = Number(p.status)
      if (Number.isFinite(stNum) && (stNum === 3 || stNum === 8)) return true
      if (p.aprovada === true || p.isApproved === true || p.approved === true) return true
      const s = String(p.status || p.situacao || p.state || '').toLowerCase()
      return s.includes('aprovad')
        || s.includes('aceit')
        || s === 'approved'
        || s.includes('ganh')
        || s.includes('conclu')
    },

    obterDataProposta(p) {
      if (!p) return 0
      const d = p.dataAprovacao || p.approvedAt || p.dataAtualizacao || p.updatedAt || p.dataCadastro || p.createdAt || p.dataCriacao || p.created_on
      if (!d) return 0
      const m = moment(d)
      if (!m.isValid()) return 0
      const ms = m.valueOf()
      return Number.isFinite(ms) ? ms : 0
    },

    statusNumeroProposta(p) {
      const st = Number(p && p.status !== undefined ? p.status : NaN)
      return Number.isFinite(st) ? st : null
    },

    selecionarFunil(value) {
      this.funilSelecionado = value
    },

    handleOpenDeal(oportunidade) {
      const oportunidadeId = oportunidade && oportunidade.id ? oportunidade.id : null
      if (!oportunidadeId) return

      const rotaAtual = this.$route
      const currentId = rotaAtual && rotaAtual.query ? rotaAtual.query.dealId : null
      const idStr = String(oportunidadeId)

      if (String(currentId) !== idStr) {
        this.$router.push({ name: 'painel-oportunidades', query: { dealId: oportunidadeId } }).catch(() => {})
        // Deixa o watcher em $route.query.dealId abrir/carregar a oportunidade
        return
      }

      // Quando o dealId já está na rota, abre diretamente sem alterar a URL
      this.abrirOportunidadeComContexto(oportunidadeId)
    },

    async carregarQuadro(funilId) {
      if (!this.$refs.oportunidadesQuadro) return
      await this.$refs.oportunidadesQuadro.carregarFunisEtapasOportunidades(funilId)
    },

    extrairPipelineIdDoDeal(deal) {
      if (!deal) return null

      const pipelineCandidates = [
        deal.pipelineId,
        deal.pipeline_id,
        deal.funilId,
        deal.pipeline && (deal.pipeline.id || deal.pipeline.pipelineId),
        deal.stage && deal.stage.pipelineId,
        deal.stage && deal.stage.pipeline && deal.stage.pipeline.id,
      ]

      const pipelineId = pipelineCandidates.find(id => id !== null && id !== undefined)
      return pipelineId || null
    },

    async localizarPipelinePorDeal(dealId) {
      const funis = Array.isArray(this.funis) ? this.funis : []
      if (!funis.length) return null

      const requisicoes = funis.map(funil => api.getPipelineWithStangesAndDeals(funil.id)
        .then(response => ({
          funilId: funil.id,
          data: response && response.data ? response.data : { stages: [] },
        }))
        .catch(() => null))

      const resultados = await Promise.all(requisicoes)
      const encontrados = resultados.filter(Boolean)

      for (let index = 0; index < encontrados.length; index += 1) {
        const resultado = encontrados[index]
        const stages = resultado.data && Array.isArray(resultado.data.stages)
          ? resultado.data.stages
          : []
        const deal = stages
          .flatMap(stage => (stage && stage.deals ? stage.deals : []))
          .find(item => String(item.id) === String(dealId))

        if (deal) {
          return resultado.funilId
        }
      }

      return null
    },

    async abrirOportunidadeComContexto(oportunidadeId) {
      if (!oportunidadeId) return

      let pipelineId = null

      try {
        const res = await api.getDealById(oportunidadeId)
        const deal = res && res.data ? res.data : null
        pipelineId = this.extrairPipelineIdDoDeal(deal)
      } catch (e) {
        pipelineId = null
      }

      if (!pipelineId) {
        pipelineId = await this.localizarPipelinePorDeal(oportunidadeId)
      }

      if (pipelineId) {
        this.funilSelecionado = pipelineId
        await this.$nextTick()
        await this.carregarQuadro(pipelineId)
      }

      this.abrirOportunidadePorId(oportunidadeId)
    },

    abrirOportunidadePorId(oportunidadeId) {
      if (!oportunidadeId) return

      const parsedId = Number(oportunidadeId)
      this.detalheOportunidadeId = Number.isFinite(parsedId) ? parsedId : oportunidadeId

      this.$nextTick(() => {
        if (this.$refs.modalDetalhesOportunidade) {
          this.$refs.modalDetalhesOportunidade.oportunidadeId = this.detalheOportunidadeId
          this.$refs.modalDetalhesOportunidade.showModal()
        }
      })
    },

    onEtapaCriada(etapaCriada) {
      if (!etapaCriada || !this.$refs.oportunidadesQuadro) return
      this.$refs.oportunidadesQuadro.adicionarNovaEtapa(etapaCriada)
    },

    onOportunidadeCriada(oportunidadeCriada) {
      if (!oportunidadeCriada || !this.$refs.oportunidadesQuadro) return
      this.$refs.oportunidadesQuadro.adicionarNovaOportunidade(oportunidadeCriada)
    },

  },
}
</script>
